import { render, staticRenderFns } from "./DownloadCard.vue?vue&type=template&id=1f966590&scoped=true&"
import script from "./DownloadCard.vue?vue&type=script&lang=js&"
export * from "./DownloadCard.vue?vue&type=script&lang=js&"
import style0 from "./DownloadCard.vue?vue&type=style&index=0&id=1f966590&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f966590",
  null
  
)

export default component.exports